var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"loading":_vm.loading,"items":_vm.messages}})
}
var staticRenderFns = []

export { render, staticRenderFns }